<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
            title="Site Map"
            icon="fas fa-map-marker-alt">
          </card-section-header>
          <!-- Map View -->
          <div class="row">
            <div class="col-md-12">
              <agm-map class="full-page-map" [latitude]="lat" [longitude]="lng" [fitBounds]="latLngBounds"
                  [fullscreenControl]="true" [mapTypeControl]="true">
                <agm-marker *ngFor="let m of markers; let i = index" (markerClick)="clickedMarker(m)"
                    [latitude]="m.lat" [longitude]="m.lng" [markerDraggable]="m.draggable">
                </agm-marker>
              </agm-map>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
